export enum DeliveryMetadataExportType {
  XmlTransform = "XmlTransform",
  MovieLabs = "MovieLabs",
  M7 = "M7",
  LiquidTransform = "LiquidTransform",
  ExcelPatcher = "ExcelPatcher",
}
